// extracted by mini-css-extract-plugin
module.exports = {"simpleLabel":"toolbarselects_simpleLabel__1NLCW","choiceBoxes":"toolbarselects_choiceBoxes__Yj8PS","simpleField":"toolbarselects_simpleField__2Uopn"};